import DOMPurify from 'dompurify';

// SVG-specific configuration for icons and graphics
export const svgSanitizeConfig = {
  ALLOWED_TAGS: [
    'svg',
    'path',
    'g',
    'circle',
    'rect',
    'line',
    'polygon',
    'polyline',
    'ellipse',
    'defs',
    'use',
  ],
  ALLOWED_ATTR: [
    'viewBox',
    'width',
    'height',
    'fill',
    'stroke',
    'stroke-width',
    'stroke-linecap',
    'stroke-linejoin',
    'd',
    'cx',
    'cy',
    'r',
    'x',
    'y',
    'x1',
    'y1',
    'x2',
    'y2',
    'points',
    'class',
    'id',
  ],
  FORBID_TAGS: ['script', 'object', 'embed', 'iframe', 'img'],
};

// HTML content configuration for medical notes and summaries
export const htmlContentSanitizeConfig = {
  ALLOWED_TAGS: [
    'p',
    'br',
    'div',
    'span',
    'strong',
    'b',
    'em',
    'i',
    'u',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'ul',
    'ol',
    'li',
    'blockquote',
    'code',
    'pre',
    'table',
    'thead',
    'tbody',
    'tr',
    'td',
    'th',
  ],
  ALLOWED_ATTR: [
    'class',
    'id',
    'style',
    'href',
    'target',
    'rel',
    'title',
    'alt',
  ],
  FORBID_TAGS: ['script', 'object', 'embed', 'iframe', 'form', 'input', 'img'],
};

export const sanitizeSvg = (content: string): string => {
  return DOMPurify.sanitize(content, svgSanitizeConfig);
};

export const sanitizeHtmlContent = (content: string): string => {
  return DOMPurify.sanitize(content, htmlContentSanitizeConfig);
};

export const sanitize = (content: string): string => {
  return DOMPurify.sanitize(content);
};
